<template>
    <div class="card">
        <div class="bg-blue-light p-2">
            <TitleButton
                :showBtn="false"
                btnTitle="Add New"
                title="Fd6 Budget Balance Summary"
            />
        </div>

        <div class="mt-2 px-2">
            <Fd6BudgetBalanceTable
                :tableData="fd6BudgetBalance"
            />
        </div>
        <GlobalLoader />
    </div>
</template>

<script setup>
import {onMounted} from 'vue';
import {useRoute} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import Fd6BudgetBalanceTable from '@/components/molecule/company/report/Fd6BudgetBalanceTable.vue'
import useReport from '@/services/modules/dashboard/report.js'

const {fd6BudgetBalance, fetchFd6BudgetBalance} = useReport()
const route = useRoute()
onMounted(() => {
  fetchFd6BudgetBalance(getQuery())
})
function getQuery () {
  return '?company_id=' + route.params.companyId
}

</script>
